import type {
  MultipleProductCard,
  SingularProductCard
} from "@shared/graphql.types";

import { PAGE_EXPERIMENT_PAIRS_WITH } from "@shared/utils.experimentation";

import { useEffect } from "react";
import { useExperimentViewed } from "tracking/hooks/useExperimentViewed";
import { PairsWith } from "../PairsWith";

type Props = {
  experimentVariant: number;
  productCards?: (SingularProductCard | MultipleProductCard)[];
  onAddToBag: (sku: string) => void;
};

export const PairsWithExperimentContainer = ({
  experimentVariant,
  productCards = [],
  onAddToBag
}: Props) => {
  const trackExperimentViewed = useExperimentViewed();

  useEffect(() => {
    trackExperimentViewed(PAGE_EXPERIMENT_PAIRS_WITH.name, experimentVariant);
  }, [experimentVariant, trackExperimentViewed]);

  // For variant 1 we will show only 1 card, for variant 2 we will show all/2 cards.
  const filteredCards = [1, 4].includes(Number(experimentVariant))
    ? productCards.slice(0, 1)
    : productCards.slice(0, 2);

  return <PairsWith productCards={filteredCards} onAddToBag={onAddToBag} />;
};
